module.exports = __webpack_public_path__ + "static/media/sh_utplan.21ffc266.png";